// extracted by mini-css-extract-plugin
export default {"updateButton":"UpdateButton_updateButton__wYiQF"};